import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const PayItemDetailsPage = lazy(() => import('./PayItemDetailsPage'));
const PayItemDetailsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Payments,
  routes: [
    {
      path: 'payments/:paymentId/payItems/:payItemId',
      element: <PayItemDetailsPage />,
    },
  ],
};

export default PayItemDetailsConfig;
